// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCs_zigKAKY9-DlqH7tjDv8m6KP1IX488w",
    authDomain: "pavans-4de9f.firebaseapp.com",
    projectId: "pavans-4de9f",
    storageBucket: "pavans-4de9f.firebasestorage.app",
    messagingSenderId: "984811245880",
    appId: "1:984811245880:web:700650213e18cd9fc1b1cd",
    measurementId: "G-2B6KRR2LVT"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider, signInWithPopup, signOut };
